import { useRef, useState } from "react";

/* Rename in place: Enter or a blur saves, Escape cancels. Enter unmounts the input, and the
   blur that follows must not send a second PATCH, hence `done`. */
export function useInlineRename(name: string, onRename: (next: string) => void) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(name);
  const done = useRef(false);

  const commit = () => {
    if (done.current) return;
    done.current = true;
    setEditing(false);
    const next = draft.trim();
    if (next && next !== name) onRename(next);
  };
  const begin = () => {
    setDraft(name);
    done.current = false;
    setEditing(true);
  };

  const inputProps = {
    autoFocus: true,
    "aria-label": "Rename",
    value: draft,
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => setDraft(e.target.value),
    onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => {
      e.stopPropagation();
      if (e.key === "Enter") commit();
      if (e.key === "Escape") { done.current = true; setDraft(name); setEditing(false); }
    },
    onBlur: commit,
  };
  return { editing, begin, inputProps };
}
